document.addEventListener('DOMContentLoaded', function () {
    function fetchCartData(callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var cart = JSON.parse(xhr.responseText);
          callback(cart);
        }
      };
      xhr.send();
    }
    function updateTopBarFreeShippingMessage(cart) {
      var freeShippingThreshold = window.themeSettings.freeShippingThreshold;
      var belowThresholdMessage = window.themeSettings.belowThresholdMessage;
      var aboveThresholdMessage = window.themeSettings.aboveThresholdMessage;
      var cartTotal = cart.total_price;
      var message = '';
      if (cartTotal === 0) {
        message = `<p class="mps--top-bar-shipping-message">
                     <a href="/pages/shipping-returns">${belowThresholdMessage}</a>
                   </p>`;
      } else if (cartTotal >= freeShippingThreshold * 100) {
        message = `<p class="mps--top-bar-shipping-message">
                     <a href="/pages/shipping-returns">${aboveThresholdMessage}</a>
                   </p>`;
      } else {
        var remaining = (freeShippingThreshold * 100 - cartTotal) / 100;
        message = `<p class="mps--top-bar-shipping-message">
                     <a href="/pages/shipping-returns">
                       Add $${remaining.toFixed(2)} to your cart to unlock FREE shipping!
                     </a>
                   </p>`;
      }
      var messageContainer = document.getElementById('mps--top-bar-shipping-message-container');
      if (messageContainer) {
        messageContainer.innerHTML = message;
      }
    }
    function refreshFreeShippingMessage() {
      fetchCartData(function (cart) {
        updateTopBarFreeShippingMessage(cart);
      });
    }
    function triggerCartUpdatedEvent() {
      const event = new Event('mps:cart:updated');
      document.body.dispatchEvent(event);
    }
    const boosterCartEvents = [
      'booster:cart:update',
      'booster:cart:clear',
      'booster:cart:upsell',
      'booster:cart:b*add',
      'booster:cart:b*modal',
      'booster:cart:b*upsell'
    ];
    boosterCartEvents.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        triggerCartUpdatedEvent();
      });
    });
    document.body.addEventListener('mps:cart:updated', function () {
      refreshFreeShippingMessage();
    });
    refreshFreeShippingMessage();
  });